import * as React from 'react'

import { Box, Skeleton, Text } from '@factorialco/deprecated-design-system'
import { groupBy } from 'lodash'

import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { PendingCardPaymentTransactionCard } from 'modules/banking/components/transactions/PendingCardPayments/PendingCardPaymentTransactionCard'
import { usePendingCardPayments } from 'modules/banking/hooks/usePendingCardPayments'
import { PendingCardPayment } from 'modules/banking/hooks/usePendingCardPayments'

interface Props {
  accountId: string
}
export const PendingCardPayments = ({ accountId }: Props) => {
  const { cardPayments, loading } = usePendingCardPayments({ accountId })

  const groupedCardPayments = groupBy(cardPayments, (cardPayment) =>
    dateBackendDateTimeToUI(cardPayment.externalCreatedAt)
  )
  return (
    <Box flex-direction="column" justifyContent="spaceBetween">
      <Box background="grey400" padding="s12">
        <Text.Normal size="300" color="grey800" weight="medium">
          {i18n.t('banking.transactions.authorizations.pending_authorization_message')}
        </Text.Normal>
      </Box>
      {loading ? (
        <Loader />
      ) : (
        Object.keys(groupedCardPayments).map((creationDate) => {
          const cardPaymentsInGroup = groupedCardPayments[creationDate]
          if (!cardPaymentsInGroup) return null
          return (
            <CardPaymentsGroup
              key={creationDate}
              creationDate={creationDate}
              cardPayments={cardPaymentsInGroup}
            />
          )
        })
      )}
    </Box>
  )
}

interface GroupProps {
  creationDate: string
  cardPayments: PendingCardPayment[]
}
const CardPaymentsGroup = ({ creationDate, cardPayments }: GroupProps) => {
  return (
    <>
      <Box paddingY="s16">
        <Text.Normal weight="semibold" size="300">
          {creationDate}
        </Text.Normal>
      </Box>

      <Box gap="s16">
        {cardPayments.map((cardPayment) => (
          <PendingCardPaymentTransactionCard cardPayment={cardPayment} key={cardPayment.id} />
        ))}
      </Box>
    </>
  )
}

const Loader = () => {
  return (
    <Box gap="s16" paddingY="s16">
      <Skeleton width="full" height="s32" />
      <Skeleton width="full" height="s32" />
      <Skeleton width="full" height="s32" />
      <Skeleton width="full" height="s32" />
      <Skeleton width="full" height="s32" />
      <Skeleton width="full" height="s32" />
    </Box>
  )
}
